export var VALUE_MODE_SETTINGS = [{
  id: 'percentage',
  label: 'Percentage',
  value: 'percentage'
}, {
  id: 'numeric',
  label: 'Numeric',
  value: 'numeric'
}];